// import React from "react";

// const vehicles = [
//   {
//     name: "Swift Dzire",
//     price: "3,900",
//     seats: "4+1 Seater",
//     type: "AC",
//     image: "/images/swift-dzire.png",
//   },
//   {
//     name: "Aura",
//     price: "3,600",
//     seats: "4+1 Seater",
//     type: "AC",
//     image: "/images/gallery/aura.jpg",
//   },
//   {
//     name: "Ertiga",
//     price: "4,500",
//     seats: "6 Seater",
//     type: "AC",
//     image: "/images/ertiga.png",
//   },
//   {
//     name: "Innova",
//     price: "5,400",
//     seats: "6 Seater",
//     type: "AC",
//     image: "/images/innova.png",
//   },
//   {
//     name: "Innova Crysta",
//     price: "6,000",
//     seats: "6 Seater",
//     type: "AC",
//     image: "/images/crysta.png",
//   },
//   {
//     name: "Urbania",
//     price: "11,500",
//     seats: "17 Seater",
//     type: "AC",
//     image: "/images/urbania.png",
//   },
//   {
//     name: "13 Traveller AC",
//     price: "8,400",
//     seats: "13 Seater",
//     type: "AC",
//     image: "/images/13travellerac.png",
//   },
//   {
//     name: "13 Traveller Non-AC",
//     price: "7,100",
//     seats: "13 Seater",
//     type: "Non AC",
//     image: "/images/13travellernonac.png",
//   },
//   {
//     name: "17 Traveller AC",
//     price: "8,500",
//     seats: "17 Seater",
//     type: "AC",
//     image: "/images/17travellerac.png",
//   },
//   {
//     name: "17 Traveller Non-AC",
//     price: "7,300",
//     seats: "17 Seater",
//     type: "Non AC",
//     image: "/images/17travellernonac.png",
//   },
//   {
//     name: "20 Traveller AC",
//     price: "9,200",
//     seats: "20 Seater",
//     type: "AC",
//     image: "/images/20travellerac.png",
//   },
//   {
//     name: "20 Traveller Non-AC",
//     price: "8,000",
//     seats: "20 Seater",
//     type: "Non AC",
//     image: "/images/20travellernonac.png",
//   },
//   {
//     name: "26 Traveller AC",
//     price: "11,800",
//     seats: "26 Seater",
//     type: "AC",
//     image: "/images/26travellerac.png",
//   },
//   {
//     name: "26 Traveller Non-AC",
//     price: "10,200",
//     seats: "26 Seater",
//     type: "Non AC",
//     image: "/images/26travellernonac.png",
//   },
//   {
//     name: "32 Seater AC",
//     price: "15,500",
//     seats: "32 Seater",
//     type: "AC",
//     image: "/images/32ac.png",
//   },
//   {
//     name: "32 Seater Non-AC",
//     price: "10,500",
//     seats: "32 Seater",
//     type: "Non AC",
//     image: "/images/32nonac.png",
//   },
//   {
//     name: "35 Seater AC",
//     price: "16,000",
//     seats: "35 Seater",
//     type: "AC",
//     image: "/images/35ac.png",
//   },
//   {
//     name: "35 Seater Non-AC",
//     price: "12,500",
//     seats: "35 Seater",
//     type: "Non AC",
//     image: "/images/35nonac.png",
//   },
//   {
//     name: "40 Seater AC",
//     price: "16,500",
//     seats: "40 Seater",
//     type: "AC",
//     image: "/images/40ac.png",
//   },
//   {
//     name: "40 Seater Non-AC",
//     price: "14,000",
//     seats: "40 Seater",
//     type: "Non AC",
//     image: "/images/40nonac.png",
//   },
//   {
//     name: "45 Seater AC",
//     price: "19,500",
//     seats: "45 Seater",
//     type: "AC",
//     image: "/images/45ac.png",
//   },
//   {
//     name: "45 Seater Non-AC",
//     price: "14,500",
//     seats: "45 Seater",
//     type: "Non AC",
//     image: "/images/gallery/45-seater-bus.jpg",
//   },
// ];

// const VehicleList = () => {
//   return (
//     <section className="vehicle-section">
//       <div className="vehicle-container">

//         {vehicles.map((vehicle, index) => {

//           const whatsappLink = `https://wa.me/917387507373?text=I want to book ${vehicle.name}`;

//           return (
//             <div className="vehicle-card" key={index}>

//               <div className="vehicle-image">
//                 <img src={vehicle.image} alt={vehicle.name} />
//               </div>

//               <div className="vehicle-details">
//                 <h3>{vehicle.name}</h3>

//                 <div className="vehicle-info">
//                   <span>Facilities:</span>
//                   <span>🚘 {vehicle.seats}</span>
//                   <span>
//                     {vehicle.type === "AC" ? "❄️ AC" : "🌤️ Non AC"}
//                   </span>
//                   <span>🚫 No Pets</span>
//                 </div>

//                 <p>Minimum 300 km per day</p>
//               </div>

//               <div className="vehicle-price-box">
//                 <h4>₹ {vehicle.price}/-</h4>

//                 <a
//                   href={whatsappLink}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="book-btn"
//                 >
//                   Book Now
//                 </a>
//               </div>

//             </div>
//           );
//         })}

//       </div>
//     </section>
//   );
// };

// export default VehicleList;


import React from "react";

const vehicles = [
  {
    name: "Dzire",
    price: "3900",
    seats: "4+1 Seater",
    type: "AC",
    image: "/images/fleetnew/Dzire.jpg",
  },

  {
    name: "Aura",
    price: "3600",
    seats: "4+1 Seater",
    type: "AC",
    image: "/images/fleetnew/Aura.jpg",
  },

  {
    name: "Ertiga",
    price: "4500",
    seats: "6 Seater",
    type: "AC",
    image: "/images/fleetnew/Ertiga.jpg",
  },
  {
    name: "Innova Crysta",
    price: "6000",
    seats: "6 Seater",
    type: "AC",
    image: "/images/fleetnew/Crysta.jpg",
  },

  {
    name: "Urbania",
    price: "11500",
    seats: "17 Seater",
    type: "AC",
    image: "/images/fleetnew/Urbania.jpg",
  },

  {
    name: "13 Seater Traveller",
    price: "8400",
    seats: "13 Seater",
    type: "AC",
    image: "/images/fleetnew/13-TravelerAC.jpg",
  },

  // {
  //   name: "13 Seater Tempo Traveller",
  //   price: "7100",
  //   seats: "13 Seater",
  //   type: "Non AC",
  //   image: "/images/fleetnew/13-TravelerNon-AC.jpg",
  // },

  {
    name: "17 Seater Tempo Traveller",
    price: "8500",
    seats: "17 Seater",
    type: "AC",
    image: "/images/fleetnew/17-AC.jpg",
  },

  {
    name: "17 Seater Tempo Traveller",
    price: "7300",
    seats: "17 Seater",
    type: "Non AC",
    image: "/images/fleetnew/17-TTNon-AC.jpg",
  },

  {
    name: "20 Seater Tempo Traveller",
    price: "9200",
    seats: "20 Seater",
    type: "AC",
    image: "/images/fleetnew/20-AC.jpg",
  },

  {
    name: "20 Seater Tempo Traveller",
    price: "8000",
    seats: "20 Seater",
    type: "Non AC",
    image: "/images/fleetnew/20-TTNon-AC.jpg",
  },

  {
    name: "26 Seater Tempo Traveller",
    price: "11800",
    seats: "26 Seater",
    type: "AC",
    image: "/images/fleetnew/26-AC.jpg",
  },

  {
    name: "26  Seater Tempo Traveller",
    price: "10200",
    seats: "26 Seater",
    type: "Non AC",
    image: "/images/fleetnew/26-TTNon-AC.jpg",
  },

  {
    name: "32 Seater Bus",
    price: "15500",
    seats: "32 Seater",
    type: "AC",
    image: "/images/fleetnew/32-SeaterAC.jpg",
  },

  {
    name: "32 Seater Bus",
    price: "10500",
    seats: "32 Seater",
    type: "Non AC",
    image: "/images/fleetnew/32-SeaterNon-AC.jpg",
  },

  {
    name: "35 Seater Bus",
    price: "16000",
    seats: "35 Seater",
    type: "AC",
    image: "/images/fleetnew/35-SeaterAC.jpg",
  },

  {
    name: "35 Seater Bus",
    price: "12500",
    seats: "35 Seater",
    type: "Non AC",
    image: "/images/fleetnew/35-SeaterNon-AC.jpg",
  },

  {
    name: "40 Seater Bus",
    price: "14000",
    seats: "40 Seater",
    type: "Non AC",
    image: "/images/fleetnew/40-SeaterNon-AC.jpg",
  },

  {
    name: "40 Seater",
    price: "16500",
    seats: "40 Seater",
    type: "AC",
    image: "/images/fleetnew/40-SeaterAC.jpg",
  },

  {
    name: "45 Seater",
    price: "19500",
    seats: "45 Seater",
    type: "AC",
    image: "/images/fleetnew/45-SeaterAC.jpg",
  },

  {
    name: "45 Seater",
    price: "14500",
    seats: "45 Seater",
    type: "Non AC",
    image: "/images/fleetnew/45-SeaterNon-AC.jpg",
  },
];

const VehicleList = () => {
  return (
    <section className="sanavi-vehicle-section">

      <div className="sanavi-vehicle-container">

        {vehicles.map((vehicle, index) => {

          const whatsappLink = `https://wa.me/917387507373?text=I want to book ${vehicle.name}`;

          return (

            <div
              className="sanavi-vehicle-card borderr"
              key={index}
            >

              <div className="sanavi-vehicle-image">
                <img
                  src={vehicle.image}
                  alt={vehicle.name}
                />
              </div>

              <div className="sanavi-vehicle-details">

                <h3>{vehicle.name}</h3>

                <div className="sanavi-vehicle-info">

                  <span>Facilities:</span>

                  <span>
                    🚘 {vehicle.seats}
                  </span>

                  <span>
                    {vehicle.type === "AC"
                      ? "❄️ AC"
                      : "🌤️ Non AC"}
                  </span>

                  <span>
                    🚫 No Pets
                  </span>

                </div>

                <p>
                  Minimum 300 km per day
                </p>

              </div>

              <div className="sanavi-price-box">

                <h4>
                  ₹ {vehicle.price}/-
                </h4>

                <a
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="sanavi-book-btn"
                >
                  Book Now
                </a>

              </div>

            </div>
          );
        })}

      </div>

    </section>
  );
};

export default VehicleList;